export default "/_next/static/chunks/fonts/symbols_pattyn-4715b609ab9d88f666503ab04ea0700b.ttf";